import { setInteractionError } from '@atlassian/react-ufo/set-interaction-error';
import { UPGRADE_SUBMIT_CHANGELIST_UFO_NAME } from 'util/ufoNameConstants';
import { checkFeatureGate, FeatureFlags } from '../util/statsig';

export const RESTRICTED_EMAIL_DOMAINS = ['ru', 'by', 'рф', 'рус', 'бел'];
export const RESTRICTED_COUNTRIES_ISO_CODES = ['RU', 'BY'];

export const setInteractionErrorUpgradeSubmitChangelist = () => {
  setInteractionError(UPGRADE_SUBMIT_CHANGELIST_UFO_NAME, {
    errorMessage: 'upgrade DC add items error',
    name: 'upgrade DC add items error',
  });
};

const countryIsoCodeChile = 'CL';
const countryIsoCodePhilippines = 'PH';
const countryIsoCodeEgypt = 'EG';
const countryIsoCodeThailand = 'TH';

export const checkIsCountryChile = (isoCountryCode: string = '') =>
  isoCountryCode === countryIsoCodeChile;

export const checkIsCountryPhilippines = (isoCountryCode: string = '') =>
  isoCountryCode === countryIsoCodePhilippines;

export const checkIsCountryEgypt = (isoCountryCode: string = '') =>
  isoCountryCode === countryIsoCodeEgypt;

export const checkIsCountryThailand = (isoCountryCode: string = '') => {
  const vatLabelsEnabled = checkFeatureGate(FeatureFlags.CART_VAT_LABELS_FOR_THAILAND);
  return vatLabelsEnabled && isoCountryCode === countryIsoCodeThailand;
};

export const getVATResponsibleCopies = (isoCountryCode: string | undefined) => {
  let taxIdPlaceholder: string;
  let VATRequiredMessageId: string;
  let VATNotRequiredMessageId: string;

  switch (isoCountryCode) {
    case countryIsoCodeChile: {
      taxIdPlaceholder = 'XX.XXX.XXX-X';
      VATRequiredMessageId = 'checkout.contact.tax-id-vat-required';
      VATNotRequiredMessageId = 'checkout.contact.tax-id-vat-not-required';
      break;
    }
    case countryIsoCodePhilippines: {
      taxIdPlaceholder = 'XXX-XXX-XXX or XXX-XXX-XXX-XXX';
      VATRequiredMessageId = 'checkout.contact.tax-id-vat-required.philippines';
      VATNotRequiredMessageId = 'checkout.contact.tax-id-vat-not-required.philippines';
      break;
    }
    case countryIsoCodeThailand: {
      taxIdPlaceholder = 'XXXXXXXXXXXXX';
      VATRequiredMessageId = 'checkout.contact.tax-id-vat-required.thailand';
      VATNotRequiredMessageId = 'checkout.contact.tax-id-vat-not-required.thailand';
      break;
    }
    default: {
      taxIdPlaceholder = '';
      VATRequiredMessageId = '';
      VATNotRequiredMessageId = '';
    }
  }

  return {
    isCountryChile: checkIsCountryChile(isoCountryCode),
    isCountryPhilippines: checkIsCountryPhilippines(isoCountryCode),
    isCountryThailand: checkIsCountryThailand(isoCountryCode),
    taxIdPlaceholder,
    VATRequiredMessageId,
    VATNotRequiredMessageId,
  };
};
